import { images } from '../constants';


const process = [ 
    {
        id: 1,
        image: images.step1,
        title: 'Assessment',
        content: 'Thorough evaluation of your window and door needs and requirements to provide tailored solutions.',
    },
    {
        id: 2,
        image: images.step2,
        title: 'Design',
        content: 'Professional design and customization of windows and doors to match your home\'s aesthetics and requirements.',
    },
    {
        id: 3,
        image: images.step3,
        title: 'Installation',
        content: 'Expert installation of windows and doors with precision and attention to detail to ensure optimal performance.',
    },
    {
        id: 4,
        image: images.step4,
        title: 'Quality Check',
        content: 'Rigorous quality checks and inspections to verify the functionality and durability of installed windows and doors.',
    },
    {
        id: 5,
        image: images.step5,
        title: 'Maintenance',
        content: 'Professional maintenance services to keep your windows and doors in optimal condition for years to come.',
    },
    {
        id: 6,
        image: images.step6,
        title: 'Customer Satisfaction',
        content: 'Dedicated to ensuring customer satisfaction by providing exceptional service and support throughout the process.',
    },
];

export default process;